export enum TerminalStatusEnum {
  OK = 'OK',
  NOWY = 'NOWY',
  PODMIENIONY = 'PODMIENIONY',
  AWARIA = 'AWARIA',
  USUNIETY = 'USUNIETY',
}
